/*
  Project: Strata Group
  Author: xfive
 */

import './modules/scrollBarWidth';
import './modules/navigation';
import Swipers from './modules/swipers';
import './modules/anchorScroll';

Swipers();
